/**
 * Toast notifications utility - Aviation-themed feedback
 * Uses React-Toastify with aviation color standards:
 * - Green (#00FF41) for success
 * - Red (#DC143C) for errors/warnings
 * - Timing: 3-4s success, 7-8s errors
 */

import { toast as rtToast } from 'react-toastify';
import type { ToastOptions } from 'react-toastify';

const SUCCESS_AUTO_CLOSE = 3500;
const ERROR_AUTO_CLOSE = 7500;
const WARNING_AUTO_CLOSE = 5000;
const INFO_AUTO_CLOSE = 4000;

const defaultOptions: ToastOptions = {
  position: 'top-right',
  closeButton: true,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: 'dark',
};

export const toast = {
  success: (message: string, options?: ToastOptions) => {
    return rtToast.success(message, {
      ...defaultOptions,
      autoClose: SUCCESS_AUTO_CLOSE,
      ...options,
    });
  },

  error: (message: string, options?: ToastOptions) => {
    return rtToast.error(message, {
      ...defaultOptions,
      autoClose: ERROR_AUTO_CLOSE,
      ...options,
    });
  },

  warning: (message: string, options?: ToastOptions) => {
    return rtToast.warning(message, {
      ...defaultOptions,
      autoClose: WARNING_AUTO_CLOSE,
      ...options,
    });
  },

  info: (message: string, options?: ToastOptions) => {
    return rtToast.info(message, {
      ...defaultOptions,
      autoClose: INFO_AUTO_CLOSE,
      ...options,
    });
  },
};
